import styled from 'styled-components';
import { Pagination, PaginationVariant } from 'ui/pagination';
import { PageSize } from 'ui/pageSize';
import { body2 } from 'ui/theme';
import { useSimpleIndexContext } from './contexts';

const PaginationContainer = styled.div`
  ${body2}
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
  display: flex;
  justify-content: space-between;
  padding: ${({ theme }) => `${theme.spacing.values.double} ${theme.spacing.values.x3}`};
`;

export const TablePagination = () => {
  const { filteredRecords, pageSize, currentPage, setCurrentPage, pageSizes, setPageSize } =
    useSimpleIndexContext();
  const totalRecords = filteredRecords.length;

  return (
    <PaginationContainer>
      <span>{totalRecords} total</span>
      <Pagination
        pages={Math.ceil(totalRecords / pageSize)}
        onChangePage={setCurrentPage}
        page={currentPage}
        variant={PaginationVariant.Grey}
      />
      <PageSize
        total={totalRecords}
        defaultSize={pageSizes[0]}
        onSelect={(size) => {
          setPageSize(size);
          setCurrentPage(1);
        }}
        pageSizes={pageSizes}
      />
    </PaginationContainer>
  );
};
